module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field__group",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('label', {
    staticClass: "field__group__label"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autofocus),
      expression: "autofocus"
    }],
    staticClass: "field__group__input no-border",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "type": "password",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "focus": function($event) {
        _vm.isActive = true
      },
      "blur": function($event) {
        _vm.isActive = false
      }
    }
  }) : (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autofocus),
      expression: "autofocus"
    }],
    staticClass: "field__group__input",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "type": "email",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "focus": function($event) {
        _vm.isActive = true
      },
      "blur": function($event) {
        _vm.isActive = false
      }
    }
  }) : (_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autofocus),
      expression: "autofocus"
    }],
    staticClass: "field__group__input",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "rows": "8",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "focus": function($event) {
        _vm.isActive = true
      },
      "blur": function($event) {
        _vm.isActive = false
      }
    }
  }) : _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autofocus),
      expression: "autofocus"
    }],
    staticClass: "field__group__input",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "type": "text",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "focus": function($event) {
        _vm.isActive = true
      },
      "blur": function($event) {
        _vm.isActive = false
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7469ffde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Field.vue
// module id = 2164
// module chunks = 0